module.exports = __webpack_public_path__ + "fonts/DIN-Regular.woff2";